import { render, staticRenderFns } from "./PageNotScreen.vue?vue&type=template&id=701117da&scoped=true&"
import script from "./PageNotScreen.vue?vue&type=script&lang=js&"
export * from "./PageNotScreen.vue?vue&type=script&lang=js&"
import style0 from "./PageNotScreen.vue?vue&type=style&index=0&id=701117da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701117da",
  null
  
)

export default component.exports